<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/HUD/HUD.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">SR-HUD and P-HUD Display System</div>
                <div class="detail-banner-desc">
                As automotive cockpits upgrade for smarter, scenario-based experiences, in-vehicle displays are shifting from single-function to multi-dimensional interaction. Integrating traditional HUDs with P-HUDs (Panorama HUDs) combines "driving info visualization" and "cockpit immersion," redefining the visual limits of human-vehicle interaction;<br />
                The SR-HUD projects key vehicle data (speed, navigation, ADAS alerts) as virtual images onto the front windshield. The P-HUD casts scenario-based info (vehicle status, detailed navigation maps, multimedia controls) directly onto the black area below the windshield. Together, they form a complementary setup: "suspended core info + panoramic extended info." This boosts driving guidance clarity and creates an immersive, relaxing cockpit, delivering safe, comfortable rides;<br />
                The SR-HUD is fully self-developed by Fengchao Electronics. Its display module uses platform-based hardware/software, with 8L volume, ＜45dB noise, 9°×3° field of view, and auto-brightness adjustment—ensuring good performance even in tough weather. Driven by Fengchao’s self-developed host system, it lets drivers adjust image height, brightness, and angle via the central display, suiting different preferences;<br />
                The P-HUD features an 11.98-inch mini-LED panel, with over 1200 nits brightness, 10000:1 contrast, and 82% color gamut. It has low-reflection design and works with sunglasses—staying clear even in strong light, offering great immersion for users.

                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">Product Introduction: SR-HUD</div>
                    <div class="detail-desc">
                        <div>
                            high resolution, clear Virtual image.
                        </div>
                        <div>
                            Reducing solar light reflection energy by 60%.
                        </div>
                        <div>
                            Automatic brightness adjustment，suitable for complex weather scenarios.
                        </div>
                        <div>
                            Working noise is less than 45dB.
                        </div>
                    </div>
                </div>

                <div class="detail-text-box">
                    <div class="detail-title">Product Introduction: P-HUD</div>
                    <div class="detail-desc">
                        <div>
                            High luminance and high contrast.
                        </div>
                        <div>
                            Ultra-Low reflection.
                        </div>
                        <div>
                            336 local dimming zones.
                        </div>
                        <div>
                            Support polarized sunglasses.
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    Core Configuration
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/HUD/HUD-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters: SR-HUD
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">1440 x 480</div>
                                    <div class="k">Resolution</div>
                                </div>

                                <div class="spec-item">
                                    <div class="v">9° x 3°</div>
                                    <div class="k">FOV</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">4.5m</div>
                                    <div class="k">VID</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">≥13,000nits</div>
                                    <div class="k">Brightness</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1200:1</div>
                                    <div class="k">Contrast</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">Unsupported</div>
                                    <div class="k">Polarized sunglasses</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">5.1 inch TFT-LCD</div>
                                    <div class="k">Technology</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="spec-row">
                    
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters: P-HUD
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">1500 x 256</div>
                                    <div class="k">Resolution</div>
                                </div>

                                <div class="spec-item">
                                    <div class="v">54° x 2.0°</div>
                                    <div class="k">FOV</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1.15m</div>
                                    <div class="k">VID</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">≥1200nits</div>
                                    <div class="k">Brightness</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">＞10000:1</div>
                                    <div class="k">Contrast</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">Support</div>
                                    <div class="k">Polarized sunglasses</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">11.98 inch TFT-LCD</div>
                                    <div class="k">Technology</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/HUD/HUD-2.jpg" alt="200-1-02">
                    </div>
                </div>

                

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
  title: 'SR-HUD and P-HUD Display System - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/electronics/HUD.html'

};

import { createApp } from 'vue';
import App from './HUD.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./HUD.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
